export const CLOUD_CALLS = {
    SSO_INTEGRATION_AUTH: 'sso-integration-auth',
};

export const SSO_TYPE = 'itarian';
